import { ICallcardFormatter } from '@addins/core/core';
import { SagaDate, SagaDatePipe } from '@app/pipes/saga-date/saga-date.pipe';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { TranslateService } from '@ngx-translate/core';
import { MyCardReceivedTimeService } from '../my-card-received-time/mycard-received-time.service';

export class FusCallcardFormatter implements ICallcardFormatter {
  constructor(private translate: TranslateService, private sagaDate: SagaDatePipe, private myCardReceivedTime: MyCardReceivedTimeService) {}

  format(callcard: CallCard) {
    callcard.name = [
      `${this.translate.instant('Mobile.CardNumberTitle')}${callcard.Id}`,
      this.sagaDate.transform(callcard.SubmittedUTC, SagaDate.SHORT)
    ]
      .filter(text => text)
      .join(' - ');

    callcard.rLong = [
      [
        `${this.translate.instant('Mobile.CardNumberTitle')}${callcard.Id}`,
        `${this.translate.instant('Mobile.Creation')}: ${this.sagaDate.transform(callcard.CreatedUTC, SagaDate.SUBMITTED)}`
      ]
        .filter(text => text)
        .join(' - '),
      [
        `${this.translate.instant(callcard.status.Name)}`,
        `${this.translate.instant('Mobile.Received')}: ${this.myCardReceivedTime.getReceivedTime(callcard)}`
      ]
        .filter(text => text)
        .join(' - ')
    ];
  }
}
